<template>
  <div class="frame-header">
    <div class="header-left" @click="jumpMgt()">
      <img src="~assets/images/logo.png" alt="logo">
      <span>蓝色星球可视化数据大屏平台</span>
    </div>
    <div class="header-center">

    </div>
    <div class="header-right">
      <user-status></user-status>
      <no-trace v-if="isAdmin && isShow"></no-trace>
      <management v-if="(isAdmin || isPlatform) && isShowManagement"></management>
    </div>
  </div>
</template>

<script>
import UserStatus from './childComps/User';
import NoTrace from './childComps/NoTrace.vue';
import Management from './childComps/Management.vue';
import _ from "underscore";

export default {
  name: 'Header',
  components: {
    UserStatus,
    NoTrace,
    Management,
  },
  computed: {
    isAdmin: function () {
      return this.$store.state.user ? (this.$store.state.user.roleInfos[0].id == '-2') : false
    },
    isPlatform: function() {
      return this.$store.state.user ? (this.$store.state.user.roleInfos[0].id == '0') : false
    },
    isShow: function () {
      return !this.$store.state.config.disabledTrace
    },
    isShowManagement: function () {
      return !this.$store.state.config.disabledManagement
    }
  },
  methods: {
    jumpMgt () {
      let self = this;
      let jumpIndexs = ['/Mgt/SpaceMgt', '/Mgt/ProjectsMgt', '/Mgt/Market']
      if (_.contains(jumpIndexs, self.$route.path)) {
        self.$router.push('/Index');
      } else {
        let spOrPrj = self.$store.state.Global.spOrPrj;
        if (!spOrPrj) {
          self.$api.sp.getCurrentModuleType().then((data) => {
            if ("space" === data)
              self.$router.push('/Mgt/SpaceMgt');
            else
              self.$router.push('/Mgt');
          })
        } else {
          if ("space" === spOrPrj)
            self.$router.push('/Mgt/SpaceMgt');
          else
            self.$router.push('/Mgt');
        }

      }

    },
  },
}
</script>